import React from 'react';

const ListingFolders = ({
  folders = [], nbMessagesByFolder = {}, selectedFolder = null, onChange
}) => {
  function numberMessages(folderName) {
    if (folderName !== 'draft' && folderName !== 'inbox' && folderName !== 'notifications') { return null; }
    if (folderName === 'draft') {
      return nbMessagesByFolder.draft;
    }
    if (folderName === 'inbox') {
      return nbMessagesByFolder.inbox;
    }
    if (folderName === 'notifications') {
      return nbMessagesByFolder.notifications;
    }
  }
  function labelNbMessages(folderName, nbMessages) {
    if (folderName !== 'draft' && folderName !== 'inbox' && folderName !== 'notifications') { return null; }
    return nbMessages > 0
      ? `(${nbMessages})`
      : null;
  }
  function handleChange(evt) {
    const folder = evt.target.value;
    onChange(folder);
  }
  return (
    <select className="pull-left form-control" value={ selectedFolder } onChange={ handleChange }>
      {
        folders.map((folderName, i) => {
          const nbMessages = numberMessages(folderName);
          return <option key={ i } value={ folderName }>{ folderName === 'trash' ? 'deleted' : folderName } { labelNbMessages(folderName, nbMessages) }</option>;
        })
      }
    </select>
  );
};

export default ListingFolders;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/ListingFolders.jsx